export enum AgentLegStatus {
    ACTIVE = 'Active',
    DISCONNECTED = 'Disconnected',
    DIALING = 'Dialing'
}